/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import MapSelector from 'components/MapSelector'

import { Mdx, Link } from '@ta-interaktiv/contentbricks'

import { MDXProvider } from '@mdx-js/react'
import styled from 'styled-components'
import DataWrapperChart from 'components/DataWrapperChart'
// TODO Set the correct article ID here
const ARTICLE_ID = '879567367291'

const MapContainer = styled.div`
  margin: auto;
  max-width: 900px;
  @media (max-width: 900px) {
    margin: auto 15px;
  }
`

export function AppComponent() {
  return (
    <MDXProvider
      components={{
        a: props => <Link allowWordWrap {...props} />,
        blockquote: props => <div className='quote-element' {...props} />
      }}
    >
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical  very fitted  segment'>
          <div className='ui container'>
            <div className='ui header'>
              <div className='ta text'>
                <Mdx
                  className='ta text'
                  file={require('text/8UB5B54OLQJC.mdx')}
                />
              </div>
            </div>
          </div>
        </header>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Patrick Meier, Andreas Moor, Dominik Balmer, Duc-Quang Nguyen
              </div>
            </div>
            <Mdx className='ta text' file={require('text/r-XyK2m695eh.mdx')} />
          </div>
        </div>

        <div className='ui vertical'>
          <div className='ui text container'>
            {/* Die erste Welle */}
            <Mdx className='ta text' file={require('text/AJXiFXk6gOMt.mdx')} />
          </div>
        </div>

        <div className='ui vertical segment'>
          <MapContainer>
            <DataWrapperChart chartId='hc4hs' height={721} autofit />
          </MapContainer>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {/* Das Tessin in der ersten Welle */}
            <Mdx className='ta text' file={require('text/C2pP2rxqLuuA.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <DataWrapperChart chartId='p3esP' height={390} autofit={false} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <Mdx className='ta text' file={require('text/fRRxA-O7L2cs.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {/* Die zweite Welle */}
            <Mdx className='ta text' file={require('text/RxcqF_TlMAjO.mdx')} />
          </div>
        </div>

        <div className='ui vertical segment'>
          <MapContainer>
            <DataWrapperChart chartId='jIiy1' height={721} />
          </MapContainer>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {/* Freiburg in der zweiten Welle */}
            <Mdx className='ta text' file={require('text/ctkQROEogl-3.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <DataWrapperChart chartId='8E304' height={400} autofit={false} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {/* Die dritte Welle */}
            <Mdx className='ta text' file={require('text/f15prslWMZR3.mdx')} />
          </div>
        </div>

        <div className='ui vertical segment'>
          <MapContainer>
            <DataWrapperChart chartId='qVYYe' height={721} />
          </MapContainer>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {/* Uri */}
            <Mdx className='ta text' file={require('text/RZ42tiT_Mnwj.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <DataWrapperChart chartId='76fm9' height={390} autofit={false} />
          </div>
        </div>

        <div className='ui vertical segment'>
          <div className='ta text chart'>
            <MapContainer>
              <MapSelector />
            </MapContainer>
          </div>
        </div>

        <Footer
          articleId={ARTICLE_ID}
          hidePortfolioTeaser
          questions={[
            'Ce contenu était-il informatif?',
            'La mise en forme vous plaît-elle?'
          ]}
          credits={[
            [
              'Données',
              `<p>L'OFSP collecte tous les cas confirmés connus de Covid-19 sur la base des rapports des hôpitaux, des laboratoires ou des médecins. Ces données sont personnelles et confidentielles. C'est pourquoi l'OFSP ne publie ces données que sous une forme agrégée, ce qui ne permet pas de tirer des conclusions sur les personnes individuelles. Les données présentées ici ont été traitées par l'OFSP à l'aide d'un script informatique initialement produit par la NZZ. Les données personnelles sont agrégées par commune, de sorte que la protection des données peut être garantie. La classification des données est effectuée à l'aide de l’algorithme de seuils naturels de <a href="https://en.wikipedia.org/wiki/Jenks_natural_breaks_optimization" target="_blank" rel="nofollow">Jenks</a>, qui garantit que les groupes présentés sont facilement distinguables. Les données agrégées ainsi que le script utilisé peuvent être consultés sur <a href="https://github.com/tamedia-ddj/2021_04_Covid_Gemeinden" target="_blank" rel="nofollow">Github</a>. Les données indiquent le lieu de résidence des personnes testées - et non le lieu d'infection.</p>`
            ]
          ]}
        />
      </div>
    </MDXProvider>
  )
}
